export const SIGN_UP = '/signup';
export const LOG_IN = '/login';
export const HOME = '/';
export const COMPETITIONS = '/competitions';
export const CREATE_COMP = '/create';
export const PROFILE = '/user';


// WEBPACK FOOTER //
// ./src/constants/routes.js